import React from "react";
import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { materialRequestLineRequestedQty } from "../utils/material-request.utils";
import { useMaterialRequestOverview } from "./MaterialRequestOverviewContext";
import { formatCurrency } from "utils/currency";

const LineItemsTab = () => {
  const { materialRequest: record } = useMaterialRequestOverview();

  const lineRows = record?.items ?? [];

  const subTotal = lineRows.reduce((sum, item) => {
    const rate = Number.isFinite(Number(item.rate)) ? Number(item.rate) : 0;
    const qty = materialRequestLineRequestedQty(item);
    return sum + rate * (Number.isFinite(Number(qty)) ? Number(qty) : 0);
  }, 0);

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <h5 className="card-title mb-0">All items in this request</h5>
            </CardHeader>
            <CardBody>
              <div className="table-responsive table-card">
                <Table className="table-nowrap align-middle mb-0">
                  <thead className="table-light text-muted">
                    <tr>
                      <th scope="col">Description</th>
                      <th scope="col">Unit</th>
                      <th scope="col" className="text-end">
                        Rate
                      </th>
                      <th scope="col" className="text-end">
                        Requested
                      </th>
                      {/* <th scope="col" className="text-end">
                        Remaining
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {lineRows.length ? (
                      lineRows.map((item, i) => {
                        const req = materialRequestLineRequestedQty(item);
                        const productId =
                          item.productId ?? item.porductId ?? undefined;
                        const description =
                          String(item.description ?? "").trim() ||
                          item.product?.name ||
                          (productId != null ? `Product #${productId}` : "—");
                        const rateValue = Number(item.rate ?? 0);
                        const safeRate = Number.isFinite(rateValue)
                          ? rateValue
                          : 0;

                        return (
                          <tr key={item.id ?? i}>
                            <td>
                              <span
                                className="text-body fw-medium"
                                style={{ whiteSpace: "pre-wrap" }}
                              >
                                {description}
                              </span>
                            </td>
                            <td className="text-muted">{item.unit ?? "—"}</td>
                            <td className="text-end tabular-nums">
                              {formatCurrency(safeRate)}
                            </td>
                            <td className="text-end tabular-nums">x{req}</td>
                            {/* <td className="text-end tabular-nums">{rem}</td> */}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-muted py-4">
                          No line items on this material request.
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot className="bg-light">
                    <tr className="fw-semibold ">
                      <th>Total</th>
                      <td colSpan={3} className="text-end pe-2 fs-5">
                        {formatCurrency(subTotal)}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default LineItemsTab;
